import { Routes, Route, Navigate } from 'react-router-dom';
import Documents from './documents/Documents';
import Dashboard from './dashboard/Dashboard';
import useAuthentication from '../../hooks/useAuthentication';
import SignIn from './SignIn';
import Users from './manageUsers/Users';
import Options from './manageOptions/Options';
import Companies from './manageCompanies/Companies';
import Plan from './managePlans/Plan';
import { useAppContext } from '../../context/Context';
import ManageFeedbacks from './manageFeedbacks/ManageFeedbacks';
import ManageSalesReps from './manageSalesRep/ManageSalesReps';
import BurgerMenu from '../chat/BurgerMenu';
import Menu from './Menu';
import Settings from "./settings/Settings";
import backgroundImage from "../chat/background.svg";
import Technical from './manageTechnical/Technical';
import ValidatePersonalInfoCode from './settings/personal_info/ValidatePersonalInfoCode';

function FadeInPage({Component}) {
    return <div className="fadeIn" key={Component}><Component/></div>
}

/** UI Component
 *
 * @constructor
 */
export default function Administration() {
    const [_, { logOut }] = useAuthentication()
    const [{ isAdminVirteem, user,isAdmin }, ] = useAppContext()
    return (
        <div className='h-screen flex w-full fadeIn'>
            {/* <Menu logOut={logOut} /> */}
            <BurgerMenu>
                <Menu logOut={logOut} company_uuid={user?.company?.uuid || ''} />
                {/*<Menu logOut={logOut} company_uuid={user?.company?.uuid || ''} />*/}
            </BurgerMenu>
            <div className='w-full bg-gray-200 overflow-auto pt-12 ' id='mainWindow' style={{ backgroundImage: `url(${backgroundImage})`, backgroundSize: 'cover', backgroundPosition: 'center' }}>
                {user != null && <Routes>
                    <Route path="/" element={isAdmin ?<FadeInPage Component={Dashboard} />: <Navigate to="/administration/" />} />
                    <Route path="/documents" element={isAdmin ?<FadeInPage Component={Documents} /> : <Navigate to="/administration/"/> }/>
                    <Route path="/feedbacks" element={isAdmin ?<FadeInPage Component={ManageFeedbacks} />: <Navigate to="/administration/" />} />
                    <Route path="/admin-commercial-virteem" element={isAdminVirteem ? <FadeInPage Component={ManageSalesReps} /> : <Navigate to="/administration/" />} />
                    <Route path="/admin-plan" element={isAdminVirteem ? <FadeInPage Component={Plan} /> : <Navigate to="/administration/" />} />
                    <Route path="/admin-companies" element={isAdminVirteem ? <FadeInPage Component={Companies} /> : <Navigate to="/administration/" />} />
                    <Route path="/admin-options" element={isAdminVirteem ? <FadeInPage Component={Options} /> : <Navigate to="/administration/" />} />
                    <Route path="/admin-users" element={isAdminVirteem ? <FadeInPage Component={Users} /> : <Navigate to="/administration/" />} />
                    <Route path="/admin-technical/*" element={isAdminVirteem ? <FadeInPage Component={Technical} /> : <Navigate to="/administration/" />} />
                    <Route path="/user/verify/:code/:email" element={<ValidatePersonalInfoCode /> }/>
                    {/* Define routes for the settings section */}
                    <Route path="/settings/*" element={<FadeInPage Component={Settings}/>} />
                    {/*<Route path="/settings/home" element={ <Navigate to="/administration/settings" />} />*/} {/*Open a new page and is not what we wish*/}
                </Routes>}
            </div>
            <SignIn />
        </div>
    );
}
